import { useMutation } from '@apollo/client';
import { Typography } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import { useNotifications, usePersistentSnackbar, type ApiOptions } from '../helpers';
import { CreateContentItemDocument } from './create.generated';

export const useCreateContentItem = (
  options: ApiOptions<typeof CreateContentItemDocument> = {},
) => {
  const { enqueueSnackbar } = useSnackbar();
  const persistentSnackbar = usePersistentSnackbar();
  const { t } = useTranslation();

  return useMutation(CreateContentItemDocument, {
    ...useNotifications(CreateContentItemDocument, {
      failure: t('api.content_items.create_error'),
    }),

    onCompleted: (data) => {
      if (data.createContentItem?.contentItem == null) {
        persistentSnackbar(t('api.content_items.create_error'), { reload: true });
        return;
      }

      enqueueSnackbar(
        <Typography color="inherit">{t('api.content_items.create_success')}</Typography>,
        {
          variant: 'success',
        },
      );
    },

    ...options,
  });
};
